import { render } from "./TemplatePage.vue?vue&type=template&id=cd904570&scoped=true"
import script from "./TemplatePage.vue?vue&type=script&lang=js"
export * from "./TemplatePage.vue?vue&type=script&lang=js"

import "./TemplatePage.vue?vue&type=style&index=0&id=cd904570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd904570"]])

export default __exports__